<template>
  <content-display :facets="['distributor']" class="p-services">
    <template v-slot:title>
      <distributor-header>
        <template slot="title">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-html="title" />
        </template>
      </distributor-header>
    </template>
    <template v-slot:default>
      <article-list :articles="articles" :route-id="$options.entryRouteId" />
    </template>
  </content-display>
</template>

<script>
  import Vue from 'vue'
  import { ROUTE_IDS, ROUTE_LIST } from '@/assets/js/util/nuxt/route'
  import ArticleList from '@/components/article-list/article-list'
  import ContentDisplay from '@/components/content-display/content-display'
  import DistributorHeader from '@/components/distributor-header/distributor-header'
  import headMixin from '@/assets/js/mixin/head'

  const ROUTE = ROUTE_LIST.find(({ id }) => id === ROUTE_IDS.SERVICES)

  export default Vue.extend({
    meta: {
      translationId: ROUTE.translationId,
    },
    components: { ArticleList, DistributorHeader, ContentDisplay },
    mixins: [headMixin],
    // @ts-ignore
    async asyncData({ $content }) {
      const articles = await $content(ROUTE.content)
        .only(['title', 'slug', 'description', 'order'])
        .sortBy('order', 'asc')
        .fetch()

      return {
        articles,
      }
    },
    computed: {
      title() {
        return this.$t(`meta.${ROUTE.translationId}.title`)
      },
    },
    entryRouteId: ROUTE_IDS.SERVICES_ENTRY,
  })
</script>
